import React, { useState, useEffect } from 'react';
import { Menu, Nav, Header, About, Projects, Contact, Footer } from './PortfolioComponents';

const Home = () => {
  const [menuState, setMenuState] = useState(false);

  const toggleMenu = () => {
    setMenuState(prevState => {
      if (!prevState) return 'active';
      return prevState === 'deactive' ? 'active' : 'deactive';
    });
  };

  useEffect(() => {
    const navbar = document.querySelector('#navbar');
    const header = document.querySelector('#welcome-section');
    const forest = document.querySelector('.forest');
    const silhouette = document.querySelector('.silhouette');
    let forestInitPos = -300;

    const handleScroll = () => {
      let scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollPos <= window.innerHeight) {
        if (silhouette) silhouette.style.bottom = `${parseInt(scrollPos / 6)}px`;
        if (forest) forest.style.bottom = `${parseInt(forestInitPos + scrollPos / 6)}px`;
      }

      if (header) {
        if (scrollPos - 100 <= window.innerHeight) {
          header.style.visibility = header.style.visibility === 'hidden' ? 'visible' : 'visible';
        } else {
          header.style.visibility = 'hidden';
        }
      }

      if (navbar) {
        if (scrollPos + 100 >= window.innerHeight) {
          navbar.classList.add('bg-active');
        } else {
          navbar.classList.remove('bg-active');
        }
      }
    };

    const setupSmoothScrolling = () => {
      const internalLinks = document.querySelectorAll('a[href^="#"]');
      internalLinks.forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault();
          const target = document.querySelector(link.hash);
          if (target) {
            target.scrollIntoView({
              block: 'start',
              behavior: 'smooth'
            });
          }
        });
      });
    };

    window.addEventListener('scroll', handleScroll);
    setupSmoothScrolling();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Menu toggleMenu={toggleMenu} showMenu={menuState} />
      <Nav toggleMenu={toggleMenu} showMenu={menuState} />
      <Header />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
